export default {
    //法语
    DiagnosticReport:'Rapport de diagnostic',
    troubleCode:'Code de défaut',
    time:'Le temps',
    noTItle:'Contrôle du fabricant',
    TestReport:"Rapport d'essai",
    VehicleInformation:'Informations sur le véhicule',
    DataStream:'Flux de données',
    IMReadiness:'Préparation I/M',
    Communication:'Protocole de communication',
    notFaultCode:'Fehlerfreier Code',
    nodataflow:'Aucun flux de données anormal',
    PositioningPrompt:'Activez la fonction de localisation pour obtenir les prix locaux.',
    FaultCode:'Code de défaut',
    AIDiagnosis:'Diagnostic IA',
    AIWait:"Rapport d'IA ou en attente de diagnostic automatique",
    FailedFaultCode:"Impossible d'obtenir les informations sur le code d'erreur",
    AIError:"Échec de l'analyse de l'IA",
    more:'Plus',
    StoredCodes:'Stored Codes',
    PendingCodes:'Pending Codes',
    PermanentCodes:'Permanent Codes',
    ManufacturerControl:'Contrôle du fabricant',
    continue:'continuer',
    // 引导定位
    notlimits:"Impossible d'obtenir l'autorisation de localisation",
    setupSteps:'Étapes de configuration :',
    openset:"Ouvrir l'application des paramètres",
    findSet:"Trouvez l'application que vous utilisez",
    clickset:'Cliquez sur "Position"',
    selectLimits:"Choisir d'utiliser pendant la période ou toujours",
    blackRefresh:"Retour à l'application pour actualiser la page",
    openAppSet:'Cliquez sur "Gestion des applications" ou "Applications"',
    findUseBrowser:'Trouvez le navigateur que vous utilisez',
    clickAuthority:'Cliquez sur "Gestion des autorisations"',
    findejurisd:'Trouver les autorisations de localisation',
    selectjurisd:"Choisir autoriser ou autoriser lors de l'utilisation",
    phoneJurisd:"Vérifiez les autorisations de localisation de l'application mobile :",
    openJurisd:'Autoriser la permission "Position"',
    report:'AI',
    AI:'Rapport',
    Freeze:'Cadre gelé',
    VoltageInfo:'Information sur la tension',
    Voltage:'tension'
}